































import Vue from "vue";
import Component from "vue-class-component";
import { MedicalInvoice } from "@/components/medicalEdit/types";
import { Prop, Emit } from "vue-property-decorator";
import InvoiceInsBurden from "@/components/medicalEdit/invoice/part/InvoiceInsBurden.vue";

@Component({
  components: {
    InvoiceInsBurden
  }
})
export default class InvoiceInsBurdens extends Vue {
  @Prop() tab!: MedicalInvoice;

  deleteItem(index: number) {
    this.deleteInsIn(index);
    this.updateTotalIns();
  }

  @Emit("addInsIn")
  addInsIn() {
    return;
  }

  @Emit("deleteInsIn")
  deleteInsIn(index: number) {
    return index;
  }

  @Emit("updateTotalIns")
  updateTotalIns() {
    return;
  }
}
